module.exports = __webpack_public_path__ + "static/media/cxj_duoyouxuan_two.d3bfb5ba.png";